<script>

export const BaseLayoutCustom = {
  props: [],
  components: {
  },

  render() {
    return (
      <b-container class="components-card">
        <b-container>
          <div>
            {this.$slots.componentOne}
          </div>
        </b-container>

        <b-container><div class="custom-space"></div></b-container>

        <b-container>
          <div class="card-tree">
            {this.$slots.componentTwo}
          </div>
        </b-container>
      </b-container>
    );
  },
};

export default BaseLayoutCustom;
</script>

<style lang="scss" scoped>

.components-card {
  width: 100%;
  display: grid;
  border-style: none;
  grid-column: 0;
}
.custom-space {
  margin-top: 2rem;
}

@media (min-width: 700px) {
  .components-card {
    grid-template-columns: 47% 6% 47%;
  }

  .custom-space {
    margin-top: 0rem;
  }
}
</style>
